import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SettingsState {
  maxResults: number;
  helpLevel: 0 | 1 | 2;
  selectedVoice?: string;
  voices?: string[];
  imagesCountLimit: number;
}

const initialState: SettingsState = {
  maxResults: 10,
  helpLevel: 2,
  selectedVoice: undefined,
  imagesCountLimit: 10,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState: initialState,
  reducers: {
    changeMaxResults: (state, action: PayloadAction<number>) => {
      state.maxResults =
        action.payload <= 10 ? (action.payload > 0 ? action.payload : 1) : 10;
    },
    setHelpLevel: (
      state,
      action: PayloadAction<typeof initialState.helpLevel>
    ) => {
      state.helpLevel = action.payload;
    },
    selectVoice: (state, action: PayloadAction<string>) => {
      state.selectedVoice = action.payload;
    },
    initVoices: (state, action: PayloadAction<string[]>) => {
      state.voices = action.payload;
    },
    setImagesCountLimit: (state, action: PayloadAction<number>) => {
      state.imagesCountLimit = action.payload >= 0 ? action.payload : 0;
    },
  },
});

export const { changeMaxResults, setHelpLevel, selectVoice, initVoices, setImagesCountLimit } =
  settingsSlice.actions;

export default settingsSlice.reducer;
